<template lang="pug">
div
  customer-profile-offer-delivery.mt-4
  template(v-if="isFetching")
    v-skeleton-loader.mt-4(type="list-item-three-line")
    v-skeleton-loader.mt-4(type="list-item-three-line")
    v-skeleton-loader.mt-4(type="list-item-three-line")
  template(v-else)
    //- SMS delivery
    sms-offer-delivery.mt-4(ref="smsOffer" :blast-data="offers[0].data")
    //- Email delivery
    email-offer-delivery.mt-4(ref="emailOffer" :blast-data="offers[1].data")
    //- Whatsapp delivery
    whatsapp-offer-delivery.mt-4(ref="whatsappOffer" :blast-data="offers[2].data")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SmsOfferDelivery from "@/components/clinic/marketing/SmsOfferDelivery.vue";
import EmailOfferDelivery from "@/components/clinic/marketing/EmailOfferDelivery.vue";
import WhatsappOfferDelivery from "@/components/clinic/marketing/WhatsappOfferDelivery.vue";
import CustomerProfileOfferDelivery from "@/components/clinic/marketing/CustomerProfileOfferDelivery.vue";

export default {
  components: { CustomerProfileOfferDelivery, WhatsappOfferDelivery, EmailOfferDelivery, SmsOfferDelivery },
  data () {
    return {
      isFetching: false,
      offers: [
        { method: 'sms', data: null },
        { method: 'email', data: null },
        { method: 'whatsapp', data: null },
      ],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedOffer: 'marketing/getOffer'
    })
  },
  mounted () {
    this.fetchDeliverance()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchDeliverance () {
      this.isFetching = true
      return this.$axios.get(`/marketing/${this.company.slug}/offers/${this.storedOffer.id}/blasts`)
        .then(resp => {
          let blasts = resp.data.results
          if (blasts.length) {
            this.$store.commit('marketing/setBlasts', blasts)
          }
          if (blasts.find(f => f.method === 'sms' && f.type === 'offer')) {
            let data = blasts.find(f => f.method === 'sms' && f.type === 'offer')
            let offer = this.offers.find(f => f.method === 'sms')
            this.$set(offer, 'data', data)
          }
          if (blasts.find(f => f.method === 'email' && f.type === 'offer')) {
            let data = blasts.find(f => f.method === 'email' && f.type === 'offer')
            let offer = this.offers.find(f => f.method === 'email')
            this.$set(offer, 'data', data)
          }
          if (blasts.find(f => f.method === 'whatsapp' && f.type === 'offer')) {
            let data = blasts.find(f => f.method === 'whatsapp' && f.type === 'offer')
            let offer = this.offers.find(f => f.method === 'whatsapp')
            this.$set(offer, 'data', data)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    validateData () {
      const isValidSms = this.$refs.smsOffer.validateData()
      const isValidEmail = this.$refs.emailOffer.validateData()
      const isValidWhatsapp = this.$refs.whatsappOffer.validateData()
      return isValidSms && isValidEmail && isValidWhatsapp
    },
    async saveData (quit) {
      const isValid = this.validateData()
      if (!isValid) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        this.$emit('error')
        return
      }
      const savingAll = [
        this.$refs.smsOffer.saveData(),
        this.$refs.emailOffer.saveData(),
        this.$refs.whatsappOffer.saveData()
      ]
      try {
        await Promise.all(savingAll)
        if (quit) {
          this.$emit('quit')
          return
        }
        this.reset()
        this.$emit('updated')
      } catch (err) {
        await this.fetchDeliverance()
        let message = this.$t('error_message.unable_to_complete_request')
        if (err.response.data) {
          if (err.response.data.detail) {
            message = err.response.data.detail
          } else {
            let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
            if (data) {
              message = data
            }
          }
        }
        this.showMessage(['error', message])
        this.$emit('error')
      }
    },
    reset () {
      this.fetchDeliverance()
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  cursor: default;
}
</style>